const TEXT_COLORS = {
  PRIMARY_900: '#181D27',
  SECONDARY_700: '#414651',
  TERTIARY_600: '#535862',
  PLACEHOLDER_SUBTLE: '#D5D7DA',
  QUATERNARY_500: '#717680',
}

const UTILS_COLORS = {
  LOTION: '#FAFAFA',
  BRIGHT_GRAY: '#E9EAEB',
  LIGHT_SILVER: '#D5D7DA',
  PALE_SKY: '#717680',
  MAKO: '#414651',
  EBONY_CLAY: '#252B37',
  WHITE_LILAC: '#F8F9FC',
  PERIWINKLE_GRAY: '#D5D9EB',
  METALLIC_SILVER: '#A4A7AE',
  WILD_SAND: '#F5F5F5',
  LIBERTY: '#4E5BA6',
  ALICE_BLUE: '#EFF6FF',
  AMERICAN_BLUE: '#363F72',
  RICH_BLACK: '#0A0D12',

  GREEN_CRAYOLA: '#17B26A',
  DARTMOUTH_GREEN: '#067647',
  SPRING_GREEN: '#099250',
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  SOFT_BLUSH: '#FEF4F2',
  CREAM_LIGHT: '#FFF4E5',
  WARM_IVORY: '#FFF6E7',
  HONEY_DEW: '#ECFDF3',
  HYPER_LINK: '#1A4FDB',
  AZURE_SKY: '#2166EF',
  FOREGROUND_DISABLED: '#A4A7AE',
  ERROR_MAIN: '#B30D01',
  ERROR_DARK: '#9E0E04',
  BLAZING_SUNSET: '#D6452C',
  AMBER_DARK: '#663C00',
  PALE_GREEN: '#ABEFC6',
  LIME_GREEN: '#067647',
  CHARCOAL_GRAY: '#252B37',
  SMOKY_BLACK: '#171919',
  VIVID_ORANGE: '#FDB022',

  WATER_BLUE: '#DAEBFF',
  PALE_BLUE: '#BEDCFF',
  SKY_BLUE: '#5DA8FD',
  DODGER_BLUE: '#3884F9',
  SPANISH_GRAY: '#94979C',
  GRANITE_GRAY: '#61656C',
}

export const COLORS = {
  PRIMARY: '#000000',
  PRIMARY_DARK: '#000000',
  PRIMARY_LIGHT: '#181D27',
  ...TEXT_COLORS,
  ...UTILS_COLORS,
}
